module.exports = __webpack_public_path__ + "static/media/clockHistoryBlue.e3bda4f9.svg";